'use strict';

exports.__esModule = true;

var _objectHelpers = require('../../../../objectHelpers');

var _constants = require('../constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var checkoutOptionsMap = _constants2.default.enhancedEcommerce.checkoutOptionsMap;

/**
 * This event tracks each step's option as the user changes it. This would be triggered AFTER a checkout step
 * has already been tracked using CheckoutStep. For example, if the user visits the "Payment Selection" step,
 * a CheckoutStep({ step: 2 }) is sent. If the user then selects "One-time Credit Card",
 * a CheckoutOption({ step: 2, option: 'ONETIME_CC' }) is sent.
 *
 * @name CheckoutOption
 * @param {TrackCheckoutOptionParams}
 */

var CheckoutOption = function CheckoutOption(_ref) {
    var step = _ref.step,
        option = _ref.option;

    _classCallCheck(this, CheckoutOption);

    this.event = 'checkoutOption';
    this.ecommerce = {
        checkout_option: {
            actionField: (0, _objectHelpers.removeUndefined)({ step: step, option: option })
        }
    };
};

exports.default = CheckoutOption;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/analytics/providers/googleTagManager/enhancedEcommerce/CheckoutOption.js
// module id = 332
// module chunks = 0